import React from "react";
import { NavLink, Link } from "react-router-dom";
const links = [{
  to: "/",
  label: "Krushers"
}, {
  to: "/wholesale",
  label: "Wholesale"
}];
export function SiteNav() {
  return <header className="sticky top-0 z-20 border-b border-line bg-paper/90 backdrop-blur" data-id="element-88" data-mp="3amzdapt24qft">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-5 py-4" data-id="element-89" data-mp="35ofs4rmafioi">
        <Link to="/" className="flex shrink-0 items-baseline gap-2 text-ink" data-id="element-90" data-mp="31mktxvznlley">
          <span className="font-display text-2xl font-bold uppercase tracking-tight" data-id="element-91" data-mp="31khtsj4sebwi">SKLUNX</span>
          <span className="hidden font-display text-lg font-semibold uppercase text-muted sm:inline" data-id="element-92" data-mp="2wpknvl2t0inu">Krushers</span>
        </Link>
        <nav aria-label="Main" className="-mr-2 flex gap-1 overflow-x-auto" data-id="element-93" data-mp="2mpk09mxwjgdu">
          {links.map(l => <NavLink key={l.to} to={l.to} end={l.to === "/"} className={({
          isActive
        }) => `whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors duration-150 ${isActive ? "bg-ink text-paper" : "text-muted hover:bg-mist hover:text-ink"}`} data-id="element-94" data-mp="pxjt4docfzz5">
              {l.label}
            </NavLink>)}
        </nav>
      </div>
    </header>;
}